// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-list-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.audit-list-container .tag-searching-input__container {
    margin-left: 2rem;
    margin-right: 2rem;
}

.audit-list{
    height: calc(100vh - 12rem);
    overflow: auto;
    margin-top: 2rem;
}

.audit-list-header {
    white-space: nowrap;
}

.audit-list-container .card-table {
    width: 100%;
}

    .audit-list-container .card-table th, .audit-list-container .card-table td {
        padding: 10px 15px;
        text-align: left;
        vertical-align: top;
    }

.audit-list-container .col-date {
    width: 15%;
    min-width: 150px;
}

.audit-list-container .col-operator {
    width: 15%;
    min-width: 120px;
    word-break: break-all;
}

.audit-list-container .col-type {
    width: 25%;
    white-space: nowrap;
}

.audit-list-container .col-data {
    width: auto;
}

.audit-badge {
    display: inline-block;
}

.audit-kv-list {
    display: flex;
    flex-direction: column;
    padding: 0px 10px;
}

.audit-kv-row {
    display: flex;
    flex-wrap: wrap; 
    align-items: baseline;
}

.audit-key {
    margin-right: 6px;
    white-space: nowrap;
}

.audit-diff-container {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.audit-diff-block {
    padding: 5px;
    text-align: left;
}

.audit-data-wrapper {
    position: relative;
    overflow: hidden;
    max-height: 150px;
    transition: max-height 0.3s ease;
}

    .audit-data-wrapper.opened::after {
        display: none;
    }
    .audit-data-wrapper.opened {
        max-height: none; 
    }

.audit-item {
    position: relative;
}

.audit-tags-container {
    display: flex;
    gap: 8px;
    margin-top: -2px;
}

    .audit-tags-container .tag {
        padding: 0.1rem 0.8rem;
        border-radius: 8px;
        border: 1px solid #26a69a;
        color: #26a69a;
        white-space: nowrap;
    }

.audit-item td {
    padding-top: 10px !important; 
    vertical-align: top;
}

.col-id {
    width: 5%; 
    position: relative;
}

.audit-expand-button-hitbox {
    display: flex;
    justify-content: center; 
    align-items: center; 
    width: 100%;
    height: 30px; 
    cursor: pointer;
    margin-top: 5px;
    background-color: transparent; 
}

.audit-expand-button {
    width: 0;
    height: 0;
    margin: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #26a69a;
    transition: transform 0.3s ease;
}

    .audit-expand-button.opened {
        transform: rotate(180deg);
    }

.col-badge {
    width: 3px; 
    padding: 0 !important;
}

.col-badge-indicator {
    padding: 2px !important;
    border: none;
}

    .col-badge-indicator.success {
        background-color: #26a69a;
    }

    .col-badge-indicator.danger {
        background-color: #d22e37;
    }

    .col-badge-indicator.warning {
        background-color: #d6ac17;
    }

@container (max-width: 1300px) {
    .audit-list-container .card-table th,
    .audit-list-container .card-table td {
        padding: 10px 5px;
    }

    .col-id {
        white-space: nowrap;
        padding: 10px 2px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/audit/audit-main/audit-list/AuditList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;IAEI;QACI,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;;AAEJ;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;IAEI;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;;AAEJ;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;IAEI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,yBAAyB;QACzB,cAAc;QACd,mBAAmB;IACvB;;AAEJ;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;IAC7B,+BAA+B;AACnC;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;AAEJ;IACI;;QAEI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ","sourcesContent":[".audit-list-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    min-height: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n.audit-list-container .tag-searching-input__container {\r\n    margin-left: 2rem;\r\n    margin-right: 2rem;\r\n}\r\n\r\n.audit-list{\r\n    height: calc(100vh - 12rem);\r\n    overflow: auto;\r\n    margin-top: 2rem;\r\n}\r\n\r\n.audit-list-header {\r\n    white-space: nowrap;\r\n}\r\n\r\n.audit-list-container .card-table {\r\n    width: 100%;\r\n}\r\n\r\n    .audit-list-container .card-table th, .audit-list-container .card-table td {\r\n        padding: 10px 15px;\r\n        text-align: left;\r\n        vertical-align: top;\r\n    }\r\n\r\n.audit-list-container .col-date {\r\n    width: 15%;\r\n    min-width: 150px;\r\n}\r\n\r\n.audit-list-container .col-operator {\r\n    width: 15%;\r\n    min-width: 120px;\r\n    word-break: break-all;\r\n}\r\n\r\n.audit-list-container .col-type {\r\n    width: 25%;\r\n    white-space: nowrap;\r\n}\r\n\r\n.audit-list-container .col-data {\r\n    width: auto;\r\n}\r\n\r\n.audit-badge {\r\n    display: inline-block;\r\n}\r\n\r\n.audit-kv-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 0px 10px;\r\n}\r\n\r\n.audit-kv-row {\r\n    display: flex;\r\n    flex-wrap: wrap; \r\n    align-items: baseline;\r\n}\r\n\r\n.audit-key {\r\n    margin-right: 6px;\r\n    white-space: nowrap;\r\n}\r\n\r\n.audit-diff-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n}\r\n\r\n.audit-diff-block {\r\n    padding: 5px;\r\n    text-align: left;\r\n}\r\n\r\n.audit-data-wrapper {\r\n    position: relative;\r\n    overflow: hidden;\r\n    max-height: 150px;\r\n    transition: max-height 0.3s ease;\r\n}\r\n\r\n    .audit-data-wrapper.opened::after {\r\n        display: none;\r\n    }\r\n    .audit-data-wrapper.opened {\r\n        max-height: none; \r\n    }\r\n\r\n.audit-item {\r\n    position: relative;\r\n}\r\n\r\n.audit-tags-container {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-top: -2px;\r\n}\r\n\r\n    .audit-tags-container .tag {\r\n        padding: 0.1rem 0.8rem;\r\n        border-radius: 8px;\r\n        border: 1px solid #26a69a;\r\n        color: #26a69a;\r\n        white-space: nowrap;\r\n    }\r\n\r\n.audit-item td {\r\n    padding-top: 10px !important; \r\n    vertical-align: top;\r\n}\r\n\r\n.col-id {\r\n    width: 5%; \r\n    position: relative;\r\n}\r\n\r\n.audit-expand-button-hitbox {\r\n    display: flex;\r\n    justify-content: center; \r\n    align-items: center; \r\n    width: 100%;\r\n    height: 30px; \r\n    cursor: pointer;\r\n    margin-top: 5px;\r\n    background-color: transparent; \r\n}\r\n\r\n.audit-expand-button {\r\n    width: 0;\r\n    height: 0;\r\n    margin: 0;\r\n    border-left: 8px solid transparent;\r\n    border-right: 8px solid transparent;\r\n    border-top: 8px solid #26a69a;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n    .audit-expand-button.opened {\r\n        transform: rotate(180deg);\r\n    }\r\n\r\n.col-badge {\r\n    width: 3px; \r\n    padding: 0 !important;\r\n}\r\n\r\n.col-badge-indicator {\r\n    padding: 2px !important;\r\n    border: none;\r\n}\r\n\r\n    .col-badge-indicator.success {\r\n        background-color: #26a69a;\r\n    }\r\n\r\n    .col-badge-indicator.danger {\r\n        background-color: #d22e37;\r\n    }\r\n\r\n    .col-badge-indicator.warning {\r\n        background-color: #d6ac17;\r\n    }\r\n\r\n@container (max-width: 1300px) {\r\n    .audit-list-container .card-table th,\r\n    .audit-list-container .card-table td {\r\n        padding: 10px 5px;\r\n    }\r\n\r\n    .col-id {\r\n        white-space: nowrap;\r\n        padding: 10px 2px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
